
import AnalysisReport from "../components/AnalysisReposrt";


function Analysis() {


// console.log(state);
return (
  <div className ="cnt" style={{ backgroundColor: "", height: "100%" }}>
    <div className="container">
      <div>
        <br></br>
      </div>
      <AnalysisReport />
    </div>
  </div>
);
}

export default Analysis;